import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { Avatar } from '@morpho-org/ui-v6/client';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Separator } from '@repo/ui';
import { memo, useMemo } from 'react';
import { getCuratorUrl } from '@/helpers/routing';
import { InternalLink } from '../InternalLink';
import QueryVaultsList from './QueryVaultsList/QueryVaultsList';
export interface RiskCuratorCardContentProps {
  curator: {
    id: string;
    name: string;
    image: string | null;
    state?: {
      aum: number;
    } | null;
  };
  chainId: ChainId | null;
}
const Curator = t0 => {
  const $ = _c(22);
  const {
    id,
    name,
    image,
    aum
  } = t0;
  let t1;
  if ($[0] !== aum) {
    t1 = formatters.short.unit("$").digits(2).default("$0.00").of(aum);
    $[0] = aum;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const totalDeposits = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "100%"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== id) {
    t3 = getCuratorUrl({
      curatorId: id
    });
    $[3] = id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== image) {
    t4 = <Avatar src={image} size="small" />;
    $[5] = image;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== name) {
    t5 = <span className="text-foreground text-xs">{name}</span>;
    $[7] = name;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== name || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className="gap-2xs flex flex-row items-center" key={name}>{t4}{t5}</div>;
    $[9] = name;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      whiteSpace: "nowrap"
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== totalDeposits) {
    t8 = <span className="text-2xs text-foreground" style={t7}>{totalDeposits}</span>;
    $[14] = totalDeposits;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <div className="px-xs py-2xs hover:bg-background flex w-full flex-row items-center justify-between rounded-[6px]">{t6}{t8}</div>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t3 || $[20] !== t9) {
    t10 = <InternalLink style={t2} href={t3} onClick={_temp}>{t9}</InternalLink>;
    $[19] = t3;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
const RiskCuratorCardContent = t0 => {
  const $ = _c(14);
  const {
    curator,
    chainId
  } = t0;
  const {
    id,
    name,
    image,
    state
  } = curator;
  const t1 = state?.aum;
  let t2;
  if ($[0] !== id || $[1] !== image || $[2] !== name || $[3] !== t1) {
    t2 = <Curator id={id} name={name} image={image} aum={t1} />;
    $[0] = id;
    $[1] = image;
    $[2] = name;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Separator />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="gap-xs px-sm pt-sm flex flex-col">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== chainId || $[9] !== id) {
    t5 = <QueryVaultsList curatorId={id} chainId={chainId} />;
    $[8] = chainId;
    $[9] = id;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="gap-2xs flex w-full flex-col">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default memo(RiskCuratorCardContent);
function _temp(e) {
  return e.stopPropagation();
}